import { z } from 'zod';

/** An explicit out-of-service assignment, never a request for a default body.
 * Null/omission retains normal release resolution during compatibility. */
export const CharacterUnavailabilitySchema = z.object({
  state: z.literal('unavailable'),
  reason: z.literal('character_withdrawn'),
  characterId: z.string().min(1),
}).strict();
export type CharacterUnavailability = z.infer<typeof CharacterUnavailabilitySchema>;
